<template>
<div>
  <div @click="goToLink" class="flex flex-wrap">
    <div class="px-1 mt-3 w-full">
      <div class="flex w-full h-full shadow-lg flex-col flex-wrap bg-cover bg-no-repeat bg-center p-5 rounded-lg overflow-hidden" style="background-image:url(https://www.alxnow.com/files/2020/10/Screen-Shot-2020-10-22-at-2.53.34-PM.jpg)">
        <div  class="flex flex-wrap justify-between items-center mt-auto py-10 px-3">
          <div class="inline-flex items-center">
          </div>
          <h2 class="text-white text-2xlg mb-2 bg-green-500 p-2 rounded-md hover:bg-green-100 hover:text-green-600 ">{{ content }}<div class="flex font-semibold text-xl justify-end mx-2 p-1">{{buttonText}}</div> </h2>
          <span class="text-white opacity-50">
        </span>
        </div>
      </div>
    </div>
</div>
</div>
</template>

<script>
import { useRouter } from 'vue-router'
export default {
  props: ['content','buttonText'],
  setup(){
    const router = useRouter()
    return {router}
  },
  methods: {
    goToLink(){
      this.router.replace({ name:'meals' })
    }
  }
}
</script>

<style>

</style>